angular.module('impactx.rfq').controller('RFQListClosedSupplierCtrl', ['$scope', '$redirect', 'selectedListItems', RFQListClosedSupplierCtrl]);

function RFQListClosedSupplierCtrl($scope, $redirect, selectedListItems)
{
    var self = this;

    this.getDetailLink = function() {
        return impactX.isDefined(selectedListItems.getFirstSelectedItem(), "isMultiSupplier.value") ?
            "multirfq/" + selectedListItems.getFirstSelectedId() : "singlerfqsupplier/" + selectedListItems.getFirstSelectedId();
    };

    var buttonDefinition = [
        {label: "details", linkFunction: self.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'RFQSupplier'}
    ];

    this.meta = {
        rowTemplate: 'modules/rfq/templates/rfqlistsupplier.row.tmpl.html',
        filtersTemplate: 'modules/rfq/templates/rfqlistsupplier.filters.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfq/listclosedsupplier',
        id: "rfqlistclosedsupplier",
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };

    this.processStatus = {value: "closed"};
    $scope.$watch(function() {
        return self.processStatus.value;
    }, function(newValue) {
        if(newValue === "open") {
            $redirect.redirectTo(null, "/rfqlistopensupplier");
        }
    });
}